export default function useDeviceCapabilities() {
  return {
    // prefersTouchCapableExperience: v,
    // supportsMixedInputExperience: l,
    // supportsMixedInputOrMouseOnlyExperience: !p || l,
    supportsTouchCapableExperience: true,
    // userAgent: o
  };
}
